import React from 'react'

import {
  Chart,
} from 'components/UI'

function handleBarClick (id, history) {
  history.push(`/buildings/${id}`)
}

const BuildingChart = ({ data, history }) => (
  <Chart.TemperatureBar
    title='Temperature / Building'
    data={data}
    onItemClick={id => handleBarClick(id, history)}
    legendWidth={150}
  />
)

export default BuildingChart



// WEBPACK FOOTER //
// ./src/components/Overview/BuildingChart.jsx